import { useUserContext } from 'src/contexts/UserContext';
import TagManager from 'react-gtm-module';
import './style.css';

import { supplierSupportWhatsappURL } from 'src/utils/whatsapp';

function ButtonPedidos() {
  const { userData } = useUserContext();

  const userName = userData?.Account_Name || userData?.razao_social || '';

  const faleConoscoTagManager = () => {
    const event = {
      dataLayer: {
        event: 'user-contact',
        username: userName,
      },
    };
    TagManager.dataLayer(event);
  };

  return (
    <a
      target="_blank"
      href={supplierSupportWhatsappURL}
      title="WhatsApp"
      onClick={faleConoscoTagManager}
      rel="noreferrer"
      id="whatsapp_icon"
      className="text-decoration-none background-green-darken-20 color-main-white"
    >
      <i className="fab fa-whatsapp" />
    </a>
  );
}

export default ButtonPedidos;
